import { Button, Drawer, Flex, Form, Input, Select, Tag } from "antd";
import axios from "axios";
import React, { useState } from "react";
import MainButtonComp from "../../../commons/Buttons/MainButtonComp";
import { useIsMobile } from "../../../design-system/useMediaQuery";
import { Error, Success } from "../../../commons/Messages/Messages";

import { useTranslation } from "react-i18next";
const UpdateRole = ({ data, employees, updateParent }) => {
  const { t } = useTranslation("dashboard");
  const isMobile = useIsMobile();
  const [form] = Form.useForm();
  const [editDrawerVisible, setEditDrawerVisible] = useState(false);
  const [roleEmployees, setRoleEmployees] = useState([]);

  const handleEditRole = async () => {
    fetchEmployeesByRole();
    form.setFieldsValue({
      title: data?.title,
      employees: data?.employees.map(emp => emp._id)
    });
    setEditDrawerVisible(true);
  };

  const fetchEmployeesByRole = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/roles/users-by-role/${data?._id}`,
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      setRoleEmployees(res.data.employees);
    } catch (err) {
      Error(err.response?.data?.errorMessage || err.message);
    }
  };

  const handleUpdateRole = async values => {
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/roles/update/${data?._id}`,
        { title: values?.title, employees: values?.employees },
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      Success(t("Role updated successfully!"));
      setEditDrawerVisible(false);
      updateParent();
    } catch (err) {
      Error(err.response?.data?.error);
    }
  };

  const handleRemoveRoleFromUser = async id => {
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/roles/users/remove-role/${data?._id}`,
        { employeeId: id },
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      Success(t("Role removed successfully!"));
    } catch (err) {
      Error(err.response?.data?.error || t("Failed to remove role."));
    }
  };

  return (
    <div>
      <MainButtonComp text="Edit" editBtn onClick={handleEditRole} />
      <Drawer
        title={t("Edit Role")}
        open={editDrawerVisible}
        onClose={() => setEditDrawerVisible(false)}
        width={isMobile ? "100%" : 400}
        footer={
          <Button type="primary" htmlType="submit" form="admin-update-role" block>
            {t("Update")}
          </Button>
        }
      >
        <Form id="admin-update-role" form={form} onFinish={handleUpdateRole} layout="vertical">
          <Form.Item
            name="title"
            label={t("Role Title")}
            rules={[{ required: true, message: t("Role title is required") }]}
          >
            <Input autoComplete="off" />
          </Form.Item>
          {roleEmployees?.length > 0 && (
            <div className="mb-3">
              <h6 className="mb-2">{t("Assigned Employees:")}</h6>
              <Flex gap={8} wrap="wrap">
                {roleEmployees?.map(emp => {
                  return (
                    <Tag
                      key={emp?._id}
                      onClose={() => handleRemoveRoleFromUser(emp?._id)}
                      bordered
                      closable
                    >
                      {emp?.firstName} {emp?.lastName}
                    </Tag>
                  );
                })}
              </Flex>
            </div>
          )}
          <Form.Item name="employees" label={t("Add New Employees")}>
            <Select mode="multiple" options={employees} />
          </Form.Item>
        </Form>
      </Drawer>
    </div>
  );
};

export default UpdateRole;
